import React from 'react';
import PropTypes from 'prop-types';

class Box extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }
    render() {
        const { content } = this.props;
        return <div className="row section company-policies-box">{content}</div>;
    }
}

Box.defaultProps = {
    content: undefined
};
Box.propTypes = {
    content: PropTypes.any
};

export default Box;



// WEBPACK FOOTER //
// ./src/components/box/index.jsx